/**
 * Avatar com lazy loading de imagem
 */

import React, { useState } from 'react';
import { Avatar, AvatarProps, Skeleton } from '@mui/material';

interface LazyAvatarProps extends AvatarProps {
  src?: string;
  alt?: string;
  loading?: 'lazy' | 'eager';
}

export const LazyAvatar: React.FC<LazyAvatarProps> = ({
  src,
  alt,
  loading = 'lazy',
  children,
  sx,
  ...props
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Se não tem src ou teve erro, mostra o children (ícone de fallback)
  if (!src || imageError) {
    return (
      <Avatar sx={sx} {...props}>
        {children}
      </Avatar>
    );
  }

  return (
    <>
      {!imageLoaded && (
        <Skeleton
          variant="rounded"
          sx={{
            ...sx,
            position: imageLoaded ? 'absolute' : 'relative',
            opacity: imageLoaded ? 0 : 1,
          }}
        />
      )}
      <Avatar
        sx={{
          ...sx,
          opacity: imageLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
        }}
        {...props}
      >
        <img
          src={src}
          alt={alt}
          loading={loading}
          onLoad={() => setImageLoaded(true)}
          onError={() => {
            setImageError(true);
            setImageLoaded(true);
          }}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Avatar>
    </>
  );
};
